import { ContainerV1Properties } from '@adobe/aem-core-components-react-spa'
import { ContainerState } from '@adobe/aem-react-editable-components'

export enum VerticalAlignment {
  top = 'start',
  middle = 'center',
  bottom = 'end'
}

export enum HorizontalAlignment {
  left = 'start',
  center = 'center',
  right = 'end',
  default = 'default'
}

export enum LayoutBackgroundTypes {
  transparent = 'transparent',
  image = 'image',
  color = 'color'
}

export interface ReactLayoutProps extends ContainerV1Properties {
  verticalAlignment: keyof typeof VerticalAlignment | string
  horizontalAlignment: keyof typeof HorizontalAlignment | string
  layoutBackground: string
  backgroundImage?: string
  backgroundColor?: string
  reverseStacking?: boolean
  // Hides only second column in mobile
  hideInMobile?: boolean
  sideSpace?: boolean
  borderRadius?: boolean
  top?: boolean
  right?: boolean
  bottom?: boolean
  left?: boolean
  lob?: string
  hideMCP?: boolean
  /**Enables layout container to stay fixed to the top of the content area while scrolling */
  isSticky?: boolean
  /**Display dismiss button (only available for 'isSticky' variant)*/
  isDismissable?: boolean
}

export interface ReactLayoutState extends ContainerState {
  dismissed?: boolean
  stickyNature?: boolean
}
